import React from 'react';
import {Modal, SecondaryButton, TertiaryButton} from '../../../../components';

export default function DeleteFlowModal({open, setOpen, onClick, loading}) {
  return (
    <Modal
      show={open}
      onClose={setOpen}
      extraModalClasses="max-w-[480px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Are you sure?"
    >
      <div>
        <p className="mt-4 text-sm text-left text-body px-6">
          By deleting this Flow, you are deleting every process, settings and
          all events tied to this flow{' '}
        </p>
      </div>

      <div className="w-full mt-6 px-6 py-[14px] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
        <SecondaryButton
          className="w-[50%] !h-10"
          buttonText="Cancel"
          onClick={() => setOpen(false)}
        />

        <TertiaryButton
          className="w-[50%] !h-10"
          onClick={onClick}
          buttonText="Delete flow"
          loading={loading}
          disabled={loading}
        />
      </div>
    </Modal>
  );
}
